'use client';

const ARCS = [
  { color: '#2172b8', w: 44,  h: 22, r: 36, timing: 'cubic-bezier(0.09, 0.3,  0.12, 0.03)' },
  { color: '#18a39b', w: 58,  h: 29, r: 42, timing: 'cubic-bezier(0.09, 0.6,  0.24, 0.03)' },
  { color: '#82c545', w: 72,  h: 36, r: 48, timing: 'cubic-bezier(0.09, 0.9,  0.36, 0.03)' },
  { color: '#f8b739', w: 86,  h: 43, r: 54, timing: 'cubic-bezier(0.09, 1.2,  0.48, 0.03)' },
  { color: '#f06045', w: 100, h: 50, r: 60, timing: 'cubic-bezier(0.09, 1.5,  0.6,  0.03)' },
  { color: '#ed2861', w: 114, h: 57, r: 66, timing: 'cubic-bezier(0.09, 1.8,  0.72, 0.03)' },
  { color: '#c12680', w: 128, h: 64, r: 72, timing: 'cubic-bezier(0.09, 2.1,  0.84, 0.03)' },
  { color: '#5d3191', w: 142, h: 71, r: 78, timing: 'cubic-bezier(0.09, 2.4,  0.96, 0.03)' },
];

interface VividSpinnerProps {
  size?: number;
  className?: string;
}

export default function VividSpinner({ size = 90, className = '' }: VividSpinnerProps) {
  const scale = size / 142;
  const bw = Math.max(2, Math.round(6 * scale));

  return (
    <div
      className={className}
      style={{
        position: 'relative',
        display: 'block',
        flexShrink: 0,
        width: size,
        height: size,
        animation: 'vivid-rotate 10s infinite linear',
      }}
    >
      {ARCS.map((arc, i) => (
        <i
          key={i}
          style={{
            position: 'absolute',
            display: 'inline-block',
            top: '50%',
            left: '50%',
            border: `solid ${bw}px transparent`,
            borderBottom: 'none',
            borderColor: arc.color,
            borderTopLeftRadius: arc.r * scale,
            borderTopRightRadius: arc.r * scale,
            width: arc.w * scale,
            height: arc.h * scale,
            marginTop: -(arc.h * scale),
            marginLeft: -(arc.w / 2 * scale),
            transformOrigin: '50% 100% 0',
            animation: `vivid-rotate 3s infinite ${arc.timing}`,
          }}
        />
      ))}
    </div>
  );
}
